import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import {
  addCommas,
  allocateRemainingPercentage,
  calculateUnits,
  calculateVintage,
  COLOR_PALETTE,
  containsPre99Drawdown,
  extractStrategies,
  findFunds,
  flagStrategies95To100,
  getStrategyNamesForFlagTrue,
  isDateInRange,
  updateFlexiAccessInvestments,
} from "../../helpers/helpers";
import Buttons from "../../atoms/Buttons";
import "./managedrawdown.scss";
import DoughnutChart from "../../atoms/DoughnutChart";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../../atoms/Icons";
import ExploreAndChangeDrawdown from "../ExploreAndChangeDrawdown";
import { ModalOverlay } from "../../atoms/Modal";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import LoadingSpinner from "../../atoms/Loader";

const ManageDrawdown = (props) => {
  const investorObject = props.memberObj?.accountDetailsForSavings?.reduce(
    (youngest, current) =>
      current.retirementAge < youngest.retirementAge ? current : youngest, // eslint-disable-line
  );
  // prettier-ignore
  const isPre99 = containsPre99Drawdown(
    props.drawdownData?.drawdownCategories
      ?.filter((category) => category?.category === "Self-managed")[0]
      .strategies?.filter(
        (strategy) => strategy.strategyName === "Flexi-access",
      )[0]?.investments,
  );

  const date = new Date(props.drawdownData?.correctDate);
  const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${date.getFullYear().toString()}`;

  const navigate = useNavigate();
  const [finalResult, setFinalResult] = useState({});
  const [showSummaryPopup, setShowSummaryPopup] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showFlexiAccess, setshowFlexiAccess] = useState(false);
  const [flexiManage, setFlexiManage] = useState(
    props.directFromManage ? true : false // eslint-disable-line
  );
  const [cmsStrategy, setCmsStrategy] = useState();
  const [back] = useState(props.back);
  const popupShown = useRef(false);
  const errorShown = useRef(false);
  const [aboutFlexiAccessDrawdown, setAboutFlexiAccessDrawdown] =
    useState(false);
  const [moreThan95, setMoreThan95] = useState(false);
  const [flaggedStrategyNames, setFlaggedStrategyNames] = useState([]);

  const { fundSwitchFetching, fundSwitchData, fundSwitchError } = useSelector(
    (state) => state.fundSwitch // eslint-disable-line
  );

  //CMS Integration starts
  const { data, fetching } = useSelector((state) => state.cmsFundListReducer);

  const { flexiAccessFetching, flexiAccessData, flexiAccessError } =
    useSelector((state) => state.flexiAccessIncome);

  const dispatch = useDispatch();

  const { getFundList, savingsFundSwitch, manageFlexiAccessIncome } =
    bindActionCreators(actionCreators, dispatch);

  const [cmsFunds, setCMSFunds] = useState([]);
  useEffect(() => {
    getFundList(props.investorId, props.drawdownData.membershipId);
  }, []);

  useEffect(() => {
    if (
      fundSwitchFetching === false &&
      fundSwitchData.every((obj) => obj.isSuccess) === true &&
      popupShown.current === true
    ) {
      if (currentInitialFlexiValue === 0) {
        updateIncome();
      } else {
        setShowSummaryPopup(false);
        setShowConfirm(true);
        errorShown.current = false;
      }
    } else if (popupShown.current === true) {
      errorShown.current = true;
    }
  }, [fundSwitchFetching, fundSwitchData, fundSwitchError]);

  useEffect(() => {
    if (
      flexiAccessData.isSuccess &&
      flexiAccessFetching === false &&
      popupShown.current === true
    ) {
      setShowSummaryPopup(false);
      setShowConfirm(true);
      errorShown.current = false;
    } else if (popupShown.current === true) {
      errorShown.current = true;
    }
  }, [flexiAccessFetching, flexiAccessData, flexiAccessError]);

  // prettier-ignore
  useEffect(() => {
    const items = data?.data?.filter(
          (cmsObject) =>
            !props.drawdownData?.drawdownCategories
          ?.filter((category) => category?.category === "Self-managed")[0]
          .strategies?.filter(
            (strategy) => strategy.strategyName === "Flexi-access",
          )[0].investments?.some(
              (composerObject) =>
                composerObject?.investmentId ===
                  cmsObject?.content?.properties?.investmentId
            ),
        );
        var colorIndex = COLOR_PALETTE.length;
        setCMSFunds(
          items?.map((item) => {
            const {
              investmentStyle,
              averageESGRating,
              fundFactsheets,
              fundUse,
              fundObjectiveTruncated,
              composerFundNameTruncated,
              investmentId,
              ...rest
            } = item.content.properties;
            if (
              isDateInRange(
                investorObject?.retirementDate,
                item.content.properties?.fundFrom,
                item.content.properties?.fundTo,
                item.content.properties?.fundName,
                isPre99 // eslint-disable-line
              ) &&
              investmentId !== null
            ) {
              return {
                investmentId: investmentId,
                fundId: composerFundNameTruncated,
                fundType:
                  investmentStyle === "Managed for you"
                    ? "Managed for me"
                    : investmentStyle,
                ESGRating: averageESGRating,
                managedBy: fundUse,
                desc: fundObjectiveTruncated,
                pDFUrl: fundFactsheets ? fundFactsheets[0].url : null,
                color: COLOR_PALETTE[--colorIndex],
                ...rest,
              };
            }
          }) // eslint-disable-line
        );
  }, [fetching, data]);
  // CMS integration ends
  useEffect(() => {
    const vintage = calculateVintage(
      props?.personInfo?.timeTravel?.birthDate?.split("-")[0] // eslint-disable-line
    );
    var colorIndex = COLOR_PALETTE.length;
    setCmsStrategy(
      findFunds(data?.data, vintage.age75Year, vintage.age95Year)
        ?.map(
          (item) => {
            const {
              investmentStyle,
              averageESGRating,
              fundFactsheets,
              fundUse,
              fundObjectiveTruncated,
              composerFundNameTruncated,
              investmentId,
              fundName,
              ...rest
            } = item;
            if (investmentId !== null) {
              return {
                strategyId: investmentId,
                strategyName: fundName,
                fundId: composerFundNameTruncated,
                fundType:
                  investmentStyle === "Managed for you"
                    ? "Managed for me"
                    : investmentStyle,
                ESGRating: averageESGRating,
                managedBy: fundUse,
                shortDesc: fundObjectiveTruncated,
                pDFUrl: fundFactsheets ? fundFactsheets[0].url : null,
                strategyPercentage: 0,
                incomePercentage: 0,
                newCurrentValue: 0,
                newCurrentIncome: 0,
                currentValue: 0,
                currentIncome: 0,
                category:
                  fundName.toLowerCase() === "future annuity income fund" ||
                  fundName.toLowerCase() === "managed income fund"
                    ? "For Income"
                    : fundName.toLowerCase() === "legacy fund" ||
                        fundName.toLowerCase() === "safety net fund"
                      ? "For Growth"
                      : "",
                color: COLOR_PALETTE[--colorIndex],
                ...rest,
              };
            }
            return null;
          } // eslint-disable-line
        )
        .filter(Boolean) // eslint-disable-line
    );
  }, [fetching, data]);

  // prettier-ignore
  const [initialStrategies, setInitialStrategies] = useState();

  // prettier-ignore
  const [currentInitialFlexiValue, setCurrentInitialFlexiValue] = useState();

  // prettier-ignore
  const [flexiAccessUpdatedCurrentValue, setFlexiAccessUpdatedCurrentValue] =
    useState();

  // prettier-ignore
  const [strategies, setStrategies] = useState();
  const [checkIsDirty, setCheckIsDirty] = useState(false);

  // prettier-ignore
  useEffect(() => {
    if (cmsStrategy != undefined) {
      setInitialStrategies(
        extractStrategies(props.drawdownData, cmsStrategy).map((strategy) => ({
          ...strategy,
          incomePercentage: isNaN(
            ((strategy?.currentIncome / strategy?.currentValue) * 100).toFixed(2)
          )
            ? 0
            : ((strategy?.currentIncome / strategy?.currentValue) * 100).toFixed(
                2
              ),
          newCurrentValue: strategy?.currentValue,
          newCurrentIncome: strategy?.currentIncome,
        }))
      );
      setStrategies(
        props.strategies
          ? props.strategies
          : [
              ...extractStrategies(props.drawdownData, cmsStrategy).map(
                (strategy) => ({
                  ...strategy,
                  incomePercentage: isNaN(
                    (
                      (strategy?.currentIncome / strategy?.currentValue) *
                      100
                    ).toFixed(2)
                  )
                    ? 0
                    : (
                        (strategy?.currentIncome / strategy?.currentValue) *
                        100
                      ).toFixed(2),
                  newCurrentValue: strategy?.currentValue,
                  newCurrentIncome: strategy?.currentIncome,
                })
              ),
            ]
      );
    }
    // setFlexiAccessUpdatedCurrentValue(props.strategies ? "" : "");
  }, [cmsStrategy, props.strategies]);

  useEffect(() => {
    const filteredInitial = initialStrategies?.filter(
      (fund) => fund.category !== "Self-managed",
    );

    const filteredStrategies = strategies?.filter(
      (fund) => fund.category !== "Self-managed",
    );

    setCheckIsDirty(
      !filteredInitial?.every((fund1) =>
        filteredStrategies?.some(
          (fund2) =>
            fund1.strategyId === fund2.strategyId &&
            parseFloat(fund1.strategyPercentage) ===
              parseFloat(fund2.strategyPercentage),
        ),
      ),
    );
  }, [initialStrategies, strategies]);

  useEffect(() => {
    setCurrentInitialFlexiValue(
      initialStrategies?.find(
        (strategy) => strategy?.strategyName === "Flexi-access" // eslint-disable-line
      ).currentValue // eslint-disable-line
    );
  }, [initialStrategies]);

  useEffect(() => {
    setFlexiAccessUpdatedCurrentValue(
      props.strategies
        ? props.strategies?.find(
            (strategy) => strategy?.strategyName === "Flexi-access" // eslint-disable-line
          ).newCurrentValue
        : initialStrategies?.find(
            (strategy) => strategy?.strategyName === "Flexi-access" // eslint-disable-line
          ).currentValue // eslint-disable-line
    );
  }, [initialStrategies]);

  // prettier-ignore
  const handleOnDrawdownSliderChange = (
    cardId,
    percentageValue,
    newCurrentValue,
    newCurrentIncome
  ) => {
    setStrategies((prevStrategy) => {
      return prevStrategy.map((strategy) => {
        if (strategy.strategyId === cardId) {
          return {
            ...strategy,
            strategyPercentage: percentageValue,
            newCurrentValue: newCurrentValue,
            newCurrentIncome: newCurrentIncome
              ? newCurrentIncome
              : strategy.currentIncome,
          };
        }
        return strategy;
      });
    });
  };

  // prettier-ignore
  const onFlexiIncomeChange = (
    flexiAcessCurrentIncome,
    flexiAccessDuration
  ) => {
    setStrategies((prevStrategy) => {
      return prevStrategy.map((strategy) => {
        if (strategy.strategyName === "Flexi-access") {
          return {
            ...strategy,
            newCurrentIncome: flexiAcessCurrentIncome,
            duration: flexiAccessDuration,
          };
        }
        return strategy;
      });
    });
  };

  const handleFlexiAccesssIncome = () => {
    setAboutFlexiAccessDrawdown(true);
  };

  // prettier-ignore
  const handleFinalSubmit = () => {
    const initialStrategiesMap = new Map(
      initialStrategies.map((obj) => [obj.strategyId, obj])
    );
    const combinedArray = strategies.map((obj2) => {
      const matchingObj = initialStrategiesMap.get(obj2.strategyId);
      if (matchingObj) {
        return {
          strategyId: obj2.strategyId,
          strategyName: obj2.strategyName,
          currentValue1: matchingObj.currentValue,
          currentIncome1: matchingObj.currentIncome,
          strategyPercentage1: matchingObj.strategyPercentage,
          currentValue2: obj2.newCurrentValue,
          currentIncome2: obj2.newCurrentIncome,
          strategyPercentage2: obj2.strategyPercentage,
          category: obj2.category,
          sellUnitPrice: obj2.sellUnitPrice,
          shortDec: "",
          investments1: matchingObj.investments,
          investments2: obj2.investments,
          duration1: matchingObj.duration,
          duration2:
            currentInitialFlexiValue === 0
              ? obj2.duration
              : matchingObj.duration,
        };
      }
    });
    
    let updatedValue = combinedArray?.find(
      (strategy) => strategy?.strategyName === "Flexi-access"
    ).currentValue2;

    if (
      (currentInitialFlexiValue === 0 &&
        flexiAccessUpdatedCurrentValue !== updatedValue) ||
      (currentInitialFlexiValue === 0 &&
        flexiAccessUpdatedCurrentValue === updatedValue &&
        back === true)
    ) {
      setShowSummaryPopup(false);
      setshowFlexiAccess(true);
    } else {
      if (currentInitialFlexiValue !== 0 && flexiManage === false) {
        combinedArray.forEach((strategy) => {
          if (strategy && strategy.strategyName === "Flexi-access") {
            updateFlexiAccessInvestments(strategy);
          }
        });
        setFinalResult(combinedArray);
      } else {
        combinedArray.forEach((strategy) => {
          if (strategy && strategy.strategyName === "Flexi-access") {
            updateFlexiAccessInvestments(strategy);
          }
        });
        setFinalResult(combinedArray);
      }
      const finalCombinedArray = flagStrategies95To100(combinedArray);
      const flaggedStrategyNames = getStrategyNamesForFlagTrue(finalCombinedArray);
      if (flaggedStrategyNames.length > 0) {
        setAboutFlexiAccessDrawdown(false);
        setMoreThan95(true);
        setFlaggedStrategyNames(flaggedStrategyNames);
      } else {
        setAboutFlexiAccessDrawdown(false);
        setShowSummaryPopup(true);
      }
    }
  };

  const handleNotificationConfirm = () => {
    setMoreThan95(false);
    setShowSummaryPopup(true);
  };

  const handleContinue = () => {
    popupShown.current = true;
    handleCurrentSubmit();
  };

  const handleCurrentSubmit = () => {
    let transformedData = {
      fromInvestments: [],
      toInvestments: [],
      strategyName: "currentInvestmentsOnly",
    };
    finalResult?.forEach((item) => {
      if (
        item &&
        parseFloat(item.strategyPercentage1) >
          parseFloat(item.strategyPercentage2)
      ) {
        transformedData.fromInvestments.push({
          investmentId: item.strategyId,
          unitAmount: calculateUnits(
            parseFloat(item.currentValue1) - parseFloat(item.currentValue2),
            item.sellUnitPrice,
          ),
        });
      } else if (item && item.strategyPercentage1 < item.strategyPercentage2) {
        transformedData.toInvestments.push({
          investmentId: item.strategyId,
          percentageAmount:
            parseFloat(item.strategyPercentage2) -
            parseFloat(item.strategyPercentage1),
          amount: item.currentValue2,
        });
      }
    });
    finalResult?.forEach((item) => {
      if (item && item.strategyName === "Flexi-access") {
        item.investments2?.forEach((investment) => {
          if (
            parseFloat(investment?.balancePercent) >
            parseFloat(investment?.fundPercentage)
          ) {
            transformedData.fromInvestments.push({
              investmentId: investment.investmentId,
              unitAmount: calculateUnits(
                parseFloat(investment?.balance) -
                  parseFloat(investment?.newBalance),
                investment?.sellUnitPrice,
              ),
            });
          } else if (
            parseFloat(investment?.balancePercent) <
            parseFloat(investment?.fundPercentage)
          ) {
            transformedData.toInvestments.push({
              investmentId: investment.investmentId,
              percentageAmount:
                parseFloat(investment?.fundPercentage) -
                parseFloat(investment?.balancePercent),
              amount: investment.newBalance,
            });
          }
        });
      }
    });
    transformedData.fromInvestments = transformedData.fromInvestments.filter(
      (investment) =>
        investment.investmentId !==
        finalResult.find((item) => item && item.strategyName === "Flexi-access")
          .strategyId // eslint-disable-line
    );
    transformedData.toInvestments = transformedData.toInvestments.filter(
      (investment) =>
        investment.investmentId !==
        finalResult.find((item) => item && item.strategyName === "Flexi-access")
          .strategyId // eslint-disable-line
    );
    transformedData = allocateRemainingPercentage(transformedData);
    //TO-DO: API call
    savingsFundSwitch(
      transformedData,
      props.investorId,
      props.drawdownData.membershipId // eslint-disable-line
    );
  };

  const updateIncome = () => {
    const flexiAccessDuration = finalResult.find(
      (item) => item && item.strategyName === "Flexi-access" // eslint-disable-line
    ).duration2;
    const flexiAcessCurrentIncome = finalResult.find(
      (item) => item && item.strategyName === "Flexi-access" // eslint-disable-line
    ).currentIncome2;
    if (flexiAcessCurrentIncome === 0) {
      setShowSummaryPopup(false);
      setShowConfirm(true);
    } else {
      const frequency =
        flexiAccessDuration === "Annually"
          ? "Annual"
          : flexiAccessDuration === "Half yearly"
            ? "HalfYearly"
            : flexiAccessDuration;
      const payload = {
        drawdownIncomeAmount: flexiAcessCurrentIncome,
        pensionPaymentFrequency: frequency,
        paymentDay: 5,
        flexibleIncomeAllowed: true,
        firstTime: true,
      };
      manageFlexiAccessIncome(
        payload,
        props.investorId,
        props.drawdownData.membershipId,
      );
    }
  };

  const handleBack = (event) => {
    event.preventDefault();
    let toggle = "drawdown";
    let drawdownMemberships = props.drawdownData;
    let combinedState = {
      toggle,
      drawdownMemberships,
    };
    navigate("/manage?tab=investments", { state: combinedState });
  };

  const handleFlexiAccessContinue = (directFromManage) => {
    setFlexiManage(directFromManage);
    var flexiAccess = true;
    var flexiAcessObject = strategies
      .filter((strategy) => strategy.category === "Self-managed")
      .find((obj) => obj.strategyName === "Flexi-access");
    if (flexiAcessObject) {
      flexiAcessObject.correctDate = formattedDate; // Add corrected-date property
      flexiAcessObject.membershipId = props?.drawdownData?.membershipId;
      flexiAcessObject.investorId = props?.investorId;
    }
    var flexiAcessInvestment = strategies
      .filter((strategy) => strategy.category === "Self-managed")
      .find((obj) => obj.strategyName === "Flexi-access").investments;
    cmsFunds.forEach((cmsFund) => {
      let match = flexiAcessInvestment.some(
        (fund) => cmsFund && fund.investmentId === cmsFund.investmentId, // eslint-disable-line
      );
      if (match) {
        cmsFund.checked = true;
      }
    });
    let combinedState = {
      flexiAccess,
      cmsFunds,
      flexiAcessObject,
      strategies,
      directFromManage,
      personInfo: props.personInfo,
    };
    navigate("/manage/investments", { state: combinedState });
  };

  const handleConfirm = () => {
    let toggle = "drawdown";
    let combinedState = {
      toggle,
    };
    navigate("/manage?tab=investments", { state: combinedState });
  };

  const handleCancel = () => {
    navigate("/manage?tab=investments");
  };

  if (cmsStrategy?.length === 0) {
    return <LoadingSpinner appLanding={true} width="100" />;
  }

  return (
    <div className="mi-parent">
      <Row className="eac-back-button mb-2 mt-3">
        <Col lg={12} md={12} sm={12} xs={12}>
          <Link className="eac-back-link" to="#" onClick={handleBack}>
            <Icons iconname="chevron-left" variant="icon-sixteen-px" />
            Back
          </Link>
        </Col>
      </Row>
      <Card className="mi-card mb-4">
        <div>
          <div className="d-none d-xl-block d-lg-block d-md-block">
            <Row className="ps-2">
              <Col xl={3} lg={3} md={3} className="doughnut-chart-small-dr">
                <div>
                  <DoughnutChart
                    percentages={strategies?.map(
                      (strategy) => strategy.strategyPercentage, // eslint-disable-line
                    )}
                    colorPallete={strategies?.map((strategy) => strategy.color)}
                    showValue={false}
                  />
                </div>
              </Col>
              <Col xl={9} lg={9} md={9} className="eac-pots-details">
                <div className="eac-pot-name">
                  {props.drawdownData?.membershipName}
                </div>
                <div className="eac-pot-value">
                  £{addCommas(Math.trunc(props.drawdownData?.totalFund))}.
                  <span className="eac-pot-value-small-digit">
                    {(props.drawdownData?.totalFund % 1)
                      .toFixed(2)
                      .substring(2)}
                  </span>
                </div>
                <div className="eac-last-checked-date">
                  As of {formattedDate}
                </div>
              </Col>
            </Row>
            <hr className="narrow-hr" />
            <div className="fund-desc-parent">
              <Row className="mb-2">
                <Col xl={10} lg={10} md={10} className="fund-desc">
                  Use the sliders to adjust the investment of your drawdown.
                  Altering Managed income or Future annuity income will also
                  change your future income. Sliders must add up to 100%. If you
                  have flexi-access drawdown then use &ldquo;Manage&ldquo; to
                  review your flexi-access investments and/or income.
                </Col>
              </Row>
              <Row>
                <Col xl={10} lg={10} md={10} className="fund-desc">
                  Fund switches are carried out using units. The amount shown is
                  an estimate and the final value may be slightly higher or
                  lower due to changes in unit prices during processing.
                </Col>
              </Row>
            </div>
          </div>
          <div className="eac-mobile-container d-block d-sm-none">
            <Card className="mobile-card">
              <Row>
                <Col xl={3} lg={3} md={3} className="mobile-dc-col">
                  <div className="mobile-doughnut-chart">
                    <DoughnutChart
                      percentages={strategies?.map(
                        (strategy) => strategy?.strategyPercentage, // eslint-disable-line
                      )}
                      colorPallete={strategies?.map(
                        (strategy) => strategy?.color, // eslint-disable-line
                      )}
                      showValue={false}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="eac-mobile-total-value">
                <div>{props.drawdownData?.membershipName}</div>
              </Row>
              <span className="eac-mobile-total-fund">
                £{addCommas(Math.trunc(props.drawdownData?.totalFund))}.
                <span className="eac-pot-value-small-digit">
                  {(props.drawdownData?.totalFund % 1).toFixed(2).substring(2)}
                </span>
              </span>
              <hr className="narrow-hr" />
              <Row className="eac-mobile-fund-dec mb-3">
                <Col xl={8} lg={8} md={8}>
                  Use the sliders to adjust the investment of your drawdown.
                  Altering Managed income or Future annuity income will also
                  change your future income. Sliders must add up to 100%. If you
                  have flexi-access drawdown then use &ldquo;Manage&ldquo; to
                  review your flexi-access investments and/or income.
                </Col>
              </Row>
            </Card>
          </div>
          <ExploreAndChangeDrawdown
            category="For Income"
            data={strategies}
            totalFund={props.drawdownData?.totalFund}
            onSliderChange={handleOnDrawdownSliderChange}
            personInfo={props?.personInfo}
            investorId={props?.investorId}
          />
          <ExploreAndChangeDrawdown
            category="Self-managed"
            data={strategies}
            totalFund={props.drawdownData?.totalFund}
            onSliderChange={handleOnDrawdownSliderChange}
            onFlexiIncomeChange={onFlexiIncomeChange}
            handleFlexiAccessContinue={handleFlexiAccessContinue}
            investorId={props?.investorId}
            investorAccountId={props?.drawdownData?.membershipId}
            AccountId={props.investorAccountId}
          />
          <ExploreAndChangeDrawdown
            category="For Growth"
            data={strategies}
            totalFund={props.drawdownData?.totalFund}
            onSliderChange={handleOnDrawdownSliderChange}
          />
        </div>
      </Card>

      <Card className="footer-card">
        <div className="footer-button">
          <div>
            <Buttons
              name="Cancel"
              className="secondary"
              variantname="icon-sixteen-px"
              handleClick={handleCancel}
            ></Buttons>
          </div>
          <div>
            <span className="funds-selected">
              Allocated{" "}
              {strategies
                ?.reduce(
                  (acc, strategy) =>
                    acc + parseFloat(strategy.strategyPercentage),
                  0, // eslint-disable-line
                )
                .toFixed(2)}
              %
            </span>
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              disabled={
                strategies
                  ?.reduce(
                    (acc, strategy) =>
                      acc + parseFloat(strategy.strategyPercentage),
                    0, // eslint-disable-line
                  )
                  .toFixed(2) != 100 || !checkIsDirty
              }
              handleClick={
                currentInitialFlexiValue === 0
                  ? handleFinalSubmit
                  : handleFlexiAccesssIncome
              }
            ></Buttons>
          </div>
        </div>
      </Card>
      <ModalOverlay
        popup="drawdownSummaryOfChanges"
        show={showSummaryPopup}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowSummaryPopup(false);
          popupShown.current === false;
        }}
        finalDrawdownStrategies={finalResult}
        handleContinue={handleContinue}
        modaltitle="Summary of changes"
        fundSwitchFetching={fundSwitchFetching}
        flexiAccessFetching={flexiAccessFetching}
        fundSwitchError={fundSwitchError}
        errorShown={errorShown.current}
      />

      <ModalOverlay
        popup="flexiAccessModal"
        show={showFlexiAccess}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setshowFlexiAccess(false);
        }}
        handleFlexiAccessContinue={handleFlexiAccessContinue}
        modaltitle="Flexi-access"
      />

      <ModalOverlay
        popup="ddchangesConfirmed"
        show={showConfirm}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowConfirm(false);
          popupShown.current === false;
        }}
        modaltitle="Changes confirmed"
        handleContinue={handleConfirm}
      />

      <ModalOverlay
        popup="AboutFlexiAccessWithdrawal"
        show={aboutFlexiAccessDrawdown}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setAboutFlexiAccessDrawdown(false);
        }}
        modaltitle="About your flexi-access fund switch"
        handleContinue={handleFinalSubmit}
        strategies={strategies}
      />
      <ModalOverlay
        popup="morethan95"
        show={moreThan95}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setMoreThan95(false);
        }}
        modaltitle="Notification"
        handleContinue={handleNotificationConfirm}
        flaggedStrategyNames={flaggedStrategyNames}
      />
    </div>
  );
};

export default ManageDrawdown;
